import { useRouter } from "next/router"

export default function CanonicalLink() {
    const router = useRouter()
    let canonical_url = (`https://app.dev.aot.plus` + (router.asPath === "/" ? "": router.asPath)).split("?")[0]
    if (router?.query?.lang == 'zh-CN') {
        canonical_url = `${canonical_url}?lang=zh-CN`
    }
    return <link rel="canonical" href={canonical_url} />
}